// src/components/GST/GroupMatchModal.js
import React from "react";
import { Modal, Table, Badge, Button, Row, Col } from "react-bootstrap";

const GroupMatchModal = ({ show, onHide, group }) => {
  if (!group) return null;

  const { gstr2b = [], erp = [], total = {}, gstin, vendor, matchType } =
    group;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Group Match Details{" "}
          <Badge bg="primary" className="ms-2">
            {matchType || "GROUP_EXACT"}
          </Badge>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="mb-2">
          <Col>
            <strong>GSTIN:</strong> {gstin}
          </Col>
          <Col>
            <strong>Vendor:</strong> {vendor}
          </Col>
        </Row>

        <h6>GSTR-2B Invoices</h6>
        <Table bordered size="sm">
          <thead>
            <tr>
              <th>Invoice</th>
              <th>Date</th>
              <th className="text-end">Taxable</th>
            </tr>
          </thead>
          <tbody>
            {gstr2b.map((g, idx) => (
              <tr key={idx}>
                <td>{g.BILL_NO}</td>
                <td>{g.BILL_DATE}</td>
                <td className="text-end">{g.TAXABLE_VALUE}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        <h6>ERP Invoices</h6>
        <Table bordered size="sm">
          <thead>
            <tr>
              <th>Invoice</th>
              <th>Date</th>
              <th className="text-end">Assessable</th>
            </tr>
          </thead>
          <tbody>
            {erp.map((p, idx) => (
              <tr key={idx}>
                <td>{p.PARTY_BILL_NO}</td>
                <td>{p.PARTY_BILL_DATE}</td>
                <td className="text-end">{p.ASSESSABLE_VALUE}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        <hr />
        <h6>Total Match Summary</h6>
        <p>
          <b>Total Taxable 2B:</b> ₹{total.taxable_2b}
        </p>
        <p>
          <b>Total Assessable ERP:</b> ₹{total.taxable_erp}
        </p>
      </Modal.Body>

      <Modal.Footer>
        {/* You can wire these buttons to group-approve / break-group APIs later */}
        <Button variant="outline-danger" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GroupMatchModal;
